module.exports = __webpack_public_path__ + "static/img/title.44abf78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/title.svg
// module id = oEbP
// module chunks = 0